export const OfficesGrid = {
	xs: 24,
	sm: 24,
	md: 12,
	lg: 12,
	xl: 12,
	xxl: 8,
};

export const FavoritesGrid = {
	xs: 24,
	sm: 24,
	md: 12,
	lg: 12,
	xl: 8,
	xxl: 8,
};

export const LinesGrid = {
	xs: 24,
	sm: 24,
	md: 24,
	lg: { span: 11, offset: 1 },
	xl: { span: 11, offset: 1 },
	xxl: { span: 11, offset: 1 },
};

export const AvatarGrid = {
	xs: 70,
	sm: 100,
	md: 90,
	lg: 90,
	xl: 100,
	xxl: 100,
};

export const categoriesWithSvgPath = [
	2, 16, 18, 19, 20, 21, 24, 3, 34, 35, 28, 104,
];

export const MAX_RESULTS_TO_RENDER = 200;
